import { VacancyProps } from "storyblok/components";
import groupBy from "lodash/groupBy";

export function sortVacancies(vacancies: Array<VacancyProps> | null) {
    if (!vacancies) return [];

    const vacanciesByCreatedAt = vacancies
        .sort((a, b) => {
            return (
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore:
                new Date(a.created_at).getTime() -
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore:
                new Date(b.created_at).getTime()
            );
        })
        .reverse();

    const vacanciesByDepartment = Object.values(
        groupBy(vacanciesByCreatedAt, "department")
    );

    const lastestVacancyByDepartment = vacanciesByDepartment
        .map(arr => arr[0])
        .filter(v => v.department !== null);

    const departmentOrder = [
        "Apotheker",
        "Apothekersassistent",
        "Artsen",
        "Basisartsen",
        "Specialist",
        "Verpleegkundigen",
        "Kantoor",
        "Studenten",
        "zzp"
    ];

    departmentOrder.forEach((department, index) => {
        const vacancy = lastestVacancyByDepartment.find(
            v => v.department === department
        );

        if (!vacancy) return;

        return lastestVacancyByDepartment.splice(index, 0, vacancy);
    });

    // checking if page is loading with a search term, if yes, then skip showing one of each department.
    let searchParam;
    if (typeof window !== "undefined") {
        searchParam = window.location.search.replace("?search=", "");
    }

    if (searchParam) {
        return [
            ...vacanciesByCreatedAt.filter(
                v => !lastestVacancyByDepartment.map(v => v.id).includes(v.id)
            )
        ];
    }

    return [
        ...lastestVacancyByDepartment,
        ...vacanciesByCreatedAt.filter(
            v => !lastestVacancyByDepartment.map(v => v.id).includes(v.id)
        )
    ];
}
